module.exports = __webpack_public_path__ + "img/weather10.b71f681c.png";